import { TODO_INIT_LOADING, TODO_INIT_SUCCESS, TODO_INIT_FAIL, TODO_ADD, TODO_REMOVE, TODO_UPDATE, TODO_UNDO, TODO_EDIT
  , TODO_COMPLETED_INIT_LOADING, TODO_COMPLETED_INIT_SUCCESS, TODO_COMPLETED_INIT_FAIL, TODO_COMPLETED_UPDATE
  , TODO_COMPLETED_LOADMORE_LOADING, TODO_COMPLETED_LOADMORE_SUCCESS, TODO_COMPLETED_LOADMORE_FAIL } from '@/store/types'

export const mutations = {
  [TODO_INIT_LOADING](state) {
    state.toDoList.init = 0
  },
  [TODO_INIT_SUCCESS](state, data) {
    state.toDoList.menu = data.menu
    state.toDoList.tasks = data.data
    state.toDoList.init = 1
  },
  [TODO_INIT_FAIL](state) {
    state.toDoList.init = 2
  },
  [TODO_ADD](state, data) {
    if (!state.toDoList.tasks.includes(data)) {
      state.toDoList.tasks.unshift(data)
    }
  },
  [TODO_REMOVE](state, data) {
    state.toDoList.tasks.map((item) => {
      if (item.id === data.id) {
        const index = state.toDoList.tasks.indexOf(item)
        state.toDoList.tasks.splice(index, 1)
      }
    })
  },
  [TODO_UPDATE](state, data) {
    state.toDoList.tasks.map((item) => {
      if (item.id === data.id) {
        item.completed = data.completed
        item.completedDate = data.completedDate
        const index = state.toDoList.tasks.indexOf(item)
        state.toDoList.tasks.splice(index, 1)
      }
    })
  },
  [TODO_UNDO](state, data) {
    if (!state.toDoList.tasks.includes(data)) {
      state.toDoList.tasks.splice(data.updatedItemIndex, 0, data)
    }
  },
  [TODO_EDIT](state, data) {
    state.toDoList.tasks.map((item) => {
      if (item.id === data.id) {
        item.description = data.description
      }
    })
  },
  [TODO_COMPLETED_INIT_LOADING](state) {
    state.completedToDoList.init = 0
  },
  [TODO_COMPLETED_INIT_SUCCESS](state, data) {
    state.completedToDoList.init = 1
    state.completedToDoList.menu = data.menu
    state.completedToDoList.tasks = data.data

    if (data.data && data.data.length > 0) {
      state.completedToDoList.hasNext = true
      state.completedToDoList.lastId = data.data[data.data.length - 1].id
    } else {
      state.completedToDoList.hasNext = false
      state.completedToDoList.lastId = 0
    }
  },
  [TODO_COMPLETED_INIT_FAIL](state) {
    state.completedToDoList.init = 2
  },
  [TODO_COMPLETED_UPDATE](state, data) {
    state.completedToDoList.tasks.map((item) => {
      if (item.id === data.id) {
        item.completed = data.completed
        item.completedDate = data.completedDate
        const index = state.completedToDoList.tasks.indexOf(item)
        state.completedToDoList.tasks.splice(index, 1)
      }
    })
    if (!state.toDoList.tasks.includes(data)) {
      state.toDoList.tasks.unshift(data)
    }
  },
  [TODO_COMPLETED_LOADMORE_LOADING](state) {
    state.completedToDoList.loadingNewCompletedToDo = true
  },
  [TODO_COMPLETED_LOADMORE_SUCCESS](state, data) {
    // Reload the menu (the next link)
    state.completedToDoList.menu = data.menu

    if (data.data && data.data.length > 0) {
      // Append new notifications
      state.completedToDoList.tasks.push.apply(state.completedToDoList.tasks, data.data)
      state.completedToDoList.hasNext = true
      state.completedToDoList.lastId = data.data[data.data.length - 1].id
    } else {
      state.completedToDoList.hasNext = false
    }

    state.completedToDoList.loadingNewCompletedToDo = false
  },
  [TODO_COMPLETED_LOADMORE_FAIL](state) {
    state.completedToDoList.loadingNewCompletedToDo = false
  }
}
